<template>
  <div
    class="ll-state-season-list"
    :class="{borderTop:borderTop}"
  >
    <TitleButton :title="$t('工廠季度')">
      <template v-slot:button>
        <WsButton001
          v-if="!edit"
          out-line
          flat-button
          narrow
          @click="$_startEdit()"
        >
          {{ $t('編輯') }}
        </WsButton001>
        <div
          v-else
          class="edit-buttons"
        >
          <WsButton001
            out-line
            flat-button
            narrow
            @click="$_cancelEdit()"
          >
            {{ $t('編輯') }}
          </WsButton001>
          <WsButton001
            flat-button
            narrow
            @click="$_saveEdit()"
          >
            {{ $t('送出') }}
          </WsButton001>
        </div>
      </template>
    </TitleButton>
    <div
      v-if="!edit"
      class="season-list"
    >
      <div
        v-for="(season_e,season_k) in _seasonList"
        :key="season_k"
        class="season-list-item"
      >
        <p class="season-list-item_title">
          {{ season_e.title }}
        </p>
        <p class="season-list-item_content">
          {{ season_e.seasonStart }} - {{ season_e.seasonEnd }}
        </p>
      </div>
    </div>
    <div
      v-else
      class="season-list input"
    >
      <div
        v-for="(season_e,season_k) in _seasonEditList"
        :key="season_k"
        class="season-list-item"
      >
        <p class="season-list-item_title">
          {{ season_e.title }}
        </p>
        <div class="season-list-item_content-input">
          <DropdownMenuButton
            v-if="!season_e.disabled"
            v-model="seasonStartMonthEditText"
            :dropdown-menu-item="monthData"
            :placeholder="durationDropdownMenuItem.placeholder"
            outline
          />
          <StatePopupRectangleButton
            v-if="season_e.disabled"
            :content-text="season_e.seasonStart"
            disabled
          />
          <p class="text">
            至
          </p>
          <StatePopupRectangleButton
            :content-text="season_e.seasonEnd"
            disabled
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlStateSeasonList",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      edit: false,
      seasonStartMonth: 0,
      seasonStartMonthText: "1",
      seasonStartMonthEditText: "1",
      monthData: [
        {
          id: "1",
          textLabel: `1${this.$t("月")}`,
        },
        {
          id: "2",
          textLabel: `2${this.$t("月")}`,
        },
        {
          id: "3",
          textLabel: `3${this.$t("月")}`,
        },
        {
          id: "4",
          textLabel: `4${this.$t("月")}`,
        },
        {
          id: "5",
          textLabel: `5${this.$t("月")}`,
        },
        {
          id: "6",
          textLabel: `6${this.$t("月")}`,
        },
        {
          id: "7",
          textLabel: `7${this.$t("月")}`,
        },
        {
          id: "8",
          textLabel: `8${this.$t("月")}`,
        },
        {
          id: "9",
          textLabel: `9${this.$t("月")}`,
        },
        {
          id: "10",
          textLabel: `10${this.$t("月")}`,
        },
        {
          id: "11",
          textLabel: `11${this.$t("月")}`,
        },
        {
          id: "12",
          textLabel: `12${this.$t("月")}`,
        },
      ],
      seasonTitle: [
        {
          id: 1,
          textLabel: this.$t("第{number}季", { number: this.$t("一") }),
        },
        {
          id: 2,
          textLabel: this.$t("第{number}季", { number: this.$t("二") }),
        },
        {
          id: 3,
          textLabel: this.$t("第{number}季", { number: this.$t("三") }),
        },
        {
          id: 4,
          textLabel: this.$t("第{number}季", { number: this.$t("四") }),
        },
      ],
      durationDropdownMenuItem: {
        placeholder: this.$t("篩選異動期間"),
        selectedMenuItem: "1",
      },
    };
  },
  computed: {
    _seasonList() {
      if (!this.value) return [];
      let fousSeasonStart = [...this._factorySeasonDates];
      let seasonList = [];
      fousSeasonStart.forEach((season, seasonIndex) => {
        let seasonDuration = {
          title: this.$_getSeasonTitle(seasonIndex + 1),
          seasonStart: this.$_getSeasonMonth(season),
          seasonEnd: this.$_getSeasonEndMonth(season),
          disabled: seasonIndex === 0 ? false : true,
        };
        seasonList.push(seasonDuration);
      });
      return seasonList;
    },
    _seasonEditList() {
      if (!this.value) return [];
      let fousSeasonStart = [...this._factorySeasonDatesEdit];
      let seasonList = [];
      fousSeasonStart.forEach((season, seasonIndex) => {
        let seasonDuration = {
          title: this.$_getSeasonTitle(seasonIndex + 1),
          seasonStart: this.$_getSeasonMonth(season),
          seasonEnd: this.$_getSeasonEndMonth(season),
          disabled: seasonIndex === 0 ? false : true,
        };
        seasonList.push(seasonDuration);
      });
      return seasonList;
    },
    _factorySeasonDates() {
      const factoryStartMonth = this.seasonStartMonth;
      const _factorySeasonDates = [];
      for (let i = 0; i < 4; i++) {
        const tarMonNumber =
          factoryStartMonth + i * 3 > 12
            ? factoryStartMonth + i * 3 - 12
            : factoryStartMonth + i * 3;
        _factorySeasonDates.push(tarMonNumber);
      }
      return _factorySeasonDates;
    },
    _factorySeasonDatesEdit() {
      const factoryStartMonth = parseInt(this.seasonStartMonthEditText);
      const _factorySeasonDates = [];
      for (let i = 0; i < 4; i++) {
        const tarMonNumber =
          factoryStartMonth + i * 3 > 12
            ? factoryStartMonth + i * 3 - 12
            : factoryStartMonth + i * 3;
        _factorySeasonDates.push(tarMonNumber);
      }
      return _factorySeasonDates;
    },
  },
  watch: {
    value() {
      this.seasonStartMonth = this.value;
      this.seasonStartMonthText = this.value.toString();
    },
    seasonStartMonthText() {
      this.seasonStartMonth = parseInt(this.seasonStartMonthText);
    },
  },
  mounted() {
    this.seasonStartMonth = this.value;
    this.seasonStartMonthText = this.value.toString();
  },
  methods: {
    $_startEdit() {
      this.$emit("start-edit");
      this.edit = true;
      this.seasonStartMonthEditText = this.seasonStartMonthText;
    },
    $_cancelEdit() {
      this.$emit("finish-edit");
      this.edit = false;
    },
    $_saveEdit() {
      this.$emit("input", parseInt(this.seasonStartMonthEditText));
      this.$emit("finish-edit", parseInt(this.seasonStartMonthEditText));
      this.edit = false;
      this.seasonStartMonthText = this.seasonStartMonthEditText;
    },
    $_getSeasonMonth(month) {
      if (!month) return "";
      let allMonthIndex = this.monthData.map((month) => month.id);
      let monthIndex = allMonthIndex.indexOf(month.toString());
      return this.monthData[monthIndex].textLabel;
    },
    $_getSeasonEndMonth(month) {
      if (!month) return;
      let endMonth;
      if (month + 2 <= 12) {
        endMonth = month + 2;
      } else if (month + 2 > 12) {
        endMonth = month - 10;
      }
      return this.$_getSeasonMonth(endMonth);
    },
    $_getSeasonTitle(id) {
      if (!id) return "";
      let allTitleIndex = this.seasonTitle.map((title) => title.id);
      let titleIndex = allTitleIndex.indexOf(id);
      return this.seasonTitle[titleIndex].textLabel;
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-state-season-list";
</style>